import Report from "../../../report";
import {ViewType} from "../../../../../gd/const/views/view-type";
import {ReportConfig} from "../../../@types";
import ReportSelfPlanning_Settings from "./settings";
import SavedView from "../../../../saved-view/saved-view";
import ApiView from "../../../../../gd/api/view";

export default class ReportSelfPlanning extends Report<ReportSelfPlanning_Settings> {

    static reportName   : string = "Self planning"

    constructor(data: ReportConfig) {
        data.type = ViewType.REPORT_SELF_PLANNING
        super(data);

        this.icon        = "isvg-self-planning"
        this.description = "Provides insights into personal planning habits and task organization."

        this.settings    = new ReportSelfPlanning_Settings(data.settings)
    }

    static initFromSavedView(savedView: SavedView): ReportSelfPlanning {
        return new ReportSelfPlanning(savedView.toReportConfig())
    }

    //Xotel dobavit po vishe. No tut raznie settings. Instance budet otlichatsya
    async getView(){
        try{
            const response = await ApiView.getView(this.id).promise()

            this.savedView = SavedView.initFromJson(response)
            //Set settings from saved view.
            this.settings  = new ReportSelfPlanning_Settings(this.savedView.data.settings)
        }
        catch(e){
            console.error(e)
        }
    }

}
